import Ivora71 from './Ivora 7 (1).webp'
import Ivora72 from './Ivora 7 (2).webp'
import Ivora73 from './Ivora 7 (3).webp'
import Ivora74 from './Ivora 7 (4).webp'
import Ivora75 from './Ivora 7 (5).webp'
import Ivora76 from './Ivora 7 (6).webp'
import Ivora77 from './Ivora 7 (7).webp'
import Ivora78 from './Ivora 7 (8).webp'
import Ivora79 from './Ivora 7 (9).webp'
import Ivora710 from './Ivora 7 (10).webp'
import Ivora711 from './Ivora 7 (11).webp'
import Ivora712 from './Ivora 7 (12).webp'
import Ivora713 from './Ivora 7 (13).webp'


const Ivora7images =[
Ivora71,Ivora72,Ivora73,Ivora74,Ivora75,Ivora76,Ivora77,Ivora78,Ivora79,Ivora710,Ivora711,Ivora712,Ivora713
]

export default Ivora7images;